<template>
  <div>
    <el-divider>{{$t('私有属性')}}</el-divider>
    <el-form-item :label="$t('链接标题')">
      <el-input v-model="data.linktitle"
                :placeholder="$t('请输入')"></el-input>
    </el-form-item>
    <el-form-item :label="$t('链接地址')">
      <el-input v-model="data.href"
                       :placeholder="$t('请输入')"></el-input>
    </el-form-item>
    <el-form-item :label="$t('链接类型')">
      <el-input v-model="data.typename"
                       :placeholder="$t('请输入')"></el-input>
    </el-form-item>
    <el-form-item :label="$t('是否下划线')">
      <el-switch v-model="data.underline"></el-switch>
    </el-form-item>
    <el-form-item :label="$t('前缀')">
      <el-input v-model="data.prepend"
                :placeholder="$t('前缀')"></el-input>
    </el-form-item>
    <el-form-item :label="$t('后缀')">
      <el-input v-model="data.append"
                :placeholder="$t('后缀')"></el-input>
    </el-form-item>
    <el-form-item :label="$t('前图标')">
        <l-input-icon onlyFirst v-model="data.prefixIcon" >
        </l-input-icon>
    </el-form-item>
    <el-form-item :label="$t('后图标')">
        <l-input-icon onlyFirst v-model="data.suffixIcon" >
        </l-input-icon>
    </el-form-item>    
    
    <el-form-item :label="$t('是否可见')">
      <el-switch v-model="data.display"></el-switch>
    </el-form-item>
    <el-form-item :label="$t('是否禁用')">
      <el-switch v-model="data.disabled"></el-switch>
    </el-form-item>
  </div>
</template>

<script>

export default {
    name: "config-linkable",
    props: ['data'],
    data () {
        return {
        }
    },
    computed: {
        validatorRules(){
            if(this.lr_validatorRules){
              return this.lr_validatorRules
            }
            else{
              return []
            }
        }
    },
    methods: {
        handleValidatorSelect(val){
            this.data.patterns.push({
                msg:`${this.$t('请输入')}${val.name}`,
                reg:val.reg
            })
        },
        handleCustmerReg(){
            this.data.patterns.push({
                msg:'',
                reg:''
            })
        },
        handleRemovePatterns(index){
            this.data.patterns.splice(index,1)
        }
    }
}
</script>

